import { Controller,Post,Body, HttpException, HttpStatus, Query, Req, Get, Delete, Param } from '@nestjs/common';
import {AuthService} from './auth.service';
import {CreateUserDto,LoginUserDto, OtpDto, SetPinDto, SignUpDto, UserIdDto, UserRoleDto, userSearchDto, VerifyOtpDto, } from '../user/dto/user.dto'
import {AllUserStatus, LoginStatus, OtpStatus, RegistrationStatus, searchResponseModel, UserStatus, UserStatusWiseResponseModel} from '../user/dto/registraton.dto';
import { ApiOperation, ApiProperty, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { JwtAuthGuard } from './jwt-auth.guard';

@ApiTags('Auth')
@Controller('auth')
export class AuthController {
  constructor(private readonly authService:AuthService) {}

  @Post('/register')  
  public async register(@Query() queryParams, @Body() createUserDto: CreateUserDto): Promise<RegistrationStatus> {    
    try {
      return await this.authService.register(queryParams,createUserDto);
    } catch (error) {
      return errorHandler(RegistrationStatus,error);
    } 
  } 

  @Post('/signup')
  @ApiOperation({summary:'user sign up from mobile application'})
  public async signup(@Query() queryParams, @Body() signupDto:SignUpDto):Promise<LoginStatus> {
    try {
      return await this.authService.signup(queryParams,signupDto);
    } catch (error) {
      return errorHandler(LoginStatus,error);
    }
  }

  @Post('/resendOtp')
  @ApiOperation({summary:'resend otp to mobile'})
  public async resendOtp(@Query() queryParams, @Body() otpDto:OtpDto, ):Promise<UserStatus> {
    try {
      return await this.authService.resendOtp(queryParams,otpDto);
    } catch (error) {
      return errorHandler(UserStatus, error);
    }
  }

  @Post('/verifyOtp')
  @ApiOperation({summary:'verify otp'})
  public async verifyOtp(@Query() queryParams, @Body() verifyOtpDto:VerifyOtpDto):Promise<OtpStatus> {
    try {
      return await this.authService.verifyOtp(queryParams, verifyOtpDto);
    } catch (error) {
      return errorHandler(OtpStatus, error);
    }
  }  

  @Post('/setPin')
  @ApiOperation({summary:'user can set pin here'})
  public async setPin(@Query() queryParams, @Body() setPinDto:SetPinDto, @Req() request:Request): Promise<UserStatus> {
    try {
      return await this.authService.setPin(queryParams, setPinDto, request);
    } catch (error) {
      return errorHandler(UserStatus, error);
    }
  }

  @Post('/login')  
  @ApiOperation({summary:'user login'})
  public async login(@Query() queryParams, @Body() loginUserDto: LoginUserDto): Promise<LoginStatus> {
    try {
      return await this.authService.login(queryParams,loginUserDto); 
    } catch(error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Post('/forgotPassword')
  @ApiOperation({summary:'forgot password'})
  public async forgotPassword(@Query() queryParams, @Body() otpDto:OtpDto):Promise<LoginStatus> {
    try {
      return await this.authService.forgotPassword(queryParams,otpDto);
    } catch (error) {
      return errorHandler(LoginStatus,error);
    }
  }

  @Post('/deleteUser')
  @ApiOperation({summary:'user soft delete'})
  public async deleteUser(@Query() queryParams, @Body() userIdDto:UserIdDto, @Req() request:Request):Promise<LoginStatus> {
    try {
      return await this.authService.deleteUser(queryParams, userIdDto, request);
    } catch (error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Post('/changeUserRole')
  @ApiOperation({summary:'2 - mla, 3 - dist head, 4 - mandal head, 5 - village head, 6 - people'})
  public async changeUserRole(@Query() queryParams, @Body() userRoleDto:UserRoleDto, @Req() request:Request):Promise<LoginStatus> {
    try {
      return await this.authService.changeUserRole(queryParams, userRoleDto, request);
    }catch (error) {
      return errorHandler(LoginStatus, error);
    }
  }

  @Get('/getAllUsers')  
  public async getAllUsers(@Query() queryParams): Promise<AllUserStatus> {
    try {
      return await this.authService.getAllUsers(queryParams);
    } catch (error) {
      return errorHandler(AllUserStatus,error);
    }      
  }   

  @Get('/getActiveUsersCount')  
  public async getActiveUsersCount(@Query() queryParams): Promise<UserStatusWiseResponseModel> {
    return await this.authService.getActiveUsersCount(queryParams);  
  } 
  
  @Post('/searchUser')
  @ApiQuery({name:'apiVersion'})
  public async getSearchUser(@Query() queryParams, @Body() userSearchDto:userSearchDto, @Req() request:Request): Promise<searchResponseModel> {
    try {
      return await this.authService.getSearchUser(queryParams,userSearchDto,request);
    } catch (error) {
      return errorHandler(searchResponseModel, error);
    }
  }

}
